import { api, authHeader } from "../configs/axiosConfigs";

const BASE = "api/admin/system";

const request = async (url, method = "GET", data = undefined) => {
  try {
    const response = await api.request({
      url,
      method,
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    const res = error?.response?.data;
    if (res) return res;
    throw error;
  }
};

const normalize = (res, fallbackMessage) => {
  const isSuccess = res?.isSuccess ?? res?.IsSuccess;
  if (!res || isSuccess === false) {
    return {
      error: res?.message || res?.Message || fallbackMessage,
      data: null,
    };
  }
  return {
    error: null,
    data: res.data ?? res.Data ?? res,
  };
};

const SystemAdminApi = {
  getHealth: () => request(`${BASE}/health`),
  getMetrics: () => request(`${BASE}/metrics`),
  getDatabaseBackupSettings: () => request(`${BASE}/database-backup/settings`),
  saveDatabaseBackupSettings: (directory) =>
    request(`${BASE}/database-backup/settings`, "PUT", { directory }),
  createDatabaseBackup: () => request(`${BASE}/database-backup`, "POST"),
  normalize,
};

export default SystemAdminApi;
